import { SOURCE, Source } from "@/constants";

const SOURCE_WITHOUT_TITLE: Source[] = [
  SOURCE.TWITTER,
  SOURCE.TIKTOK,
  SOURCE.FACEBOOK,
  SOURCE.INSTAGRAM,
  SOURCE.LINKEDIN,
];

/**
 * The titles of social media posts don't have their own titles, instead
 * we're sent a generic title like "InstagramPost" or TikTokVideo".
 * This function checks if a source has a title or not.
 */
const isSourceWithTitle = (source: Source): boolean => {
  return !SOURCE_WITHOUT_TITLE.includes(source);
};

export default isSourceWithTitle;
